import React from 'react'
import SmartImplant from '../../../../dental/mobile/LevelTwo/SmartImplant';
import image from "../../../../../assets/images/CYROTH_Corte.png";

const Cyroth = (props) => {
	return (
		<SmartImplant
			image={image}
			reference={1}
			system='conicalConnection'
		/>
	)
}

export default Cyroth